import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import dayjs from 'dayjs';
import styles from './ZtListAuto.module.less';

import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import { setTopImgVideoVisible } from '../../actions/layout';
import zt_blank from '../../static/zt_blank.png';
import { setIframeVisible } from '../../actions/layout';
import { logNative, getUrlByTargetContent } from '../../utils/utils';
import { useInView } from 'react-intersection-observer';
import { useAliveController } from 'react-activation';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const [showName, setShowName] = useState('');
  const [code, setCode] = useState('');
  const [pageType, setPageType] = useState('');
  const [showSofts, setShowSofts] = useState([]);
  const [contentClass, setContentClass] = useState(styles.content_column3);
  const [showData, setShowData] = useState(null);
  const { dropScope } = useAliveController();

  const LOG_ACTION_SOURCE = {
    c_hanlde_more: `${logInfo.tag}_ZtList_More`,
    c_hanlde: `${logInfo.tag}_ZtList`,
    source: `${logInfo.tag}_ZtList`,
  };

  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
      });
    }
  }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (data && data.dataList && data.dataList.length > 0 && data.dataList[0].ztList) {
      const pageSize = parseInt(data.row || 1, 10) * 3;
      const showSoftArr = data.dataList[0].ztList;
      setShowSofts(showSoftArr);
      // 可展示应用个数小于配置的需要展示应用数，则只显示一行即为3个
      // if (showSoftArr.length < pageSize) {
      //   setShowSofts(showSoftArr.slice(0, 3));
      // } else {
      //   setShowSofts(showSoftArr.slice(0, pageSize));
      // }
      setShowName(data.title);
      setCode(data.dataList[0].code);
      setShowData(data.dataList[0]);
      setPageType(data.pageType);
    }

    if (data && data.column && data.row) {
      if (data.column === '3') {
        setContentClass(styles.content_column3);
      }
    }
  }, [dispatch, data]);

  // const handleZtMore = useCallback(() => {
  //   dispatch(
  //     logging({
  //       category: 'C',
  //       action: LOG_ACTION_SOURCE.c_hanlde_more,
  //       label: '',
  //       param2: {
  //         source: `${LOG_ACTION_SOURCE.source}||${code}`,
  //         source_p: logInfoData.source_p,
  //         source_pp: logInfoData.source_pp,
  //         code,
  //         showName,
  //         pageType,
  //       },
  //     }),
  //   );
  //   dispatch(
  //     logPostInfo({
  //       source_p: `${LOG_ACTION_SOURCE.source}||${code}`,
  //       source_pp: logInfoData.source_p,
  //     }),
  //   );
  // }, [code, showName, pageType]);

  const handleZtCard = useCallback(
    zt => {
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_hanlde,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${zt.pageCardContentId}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            code,
            showName,
            pageType,
            ztId: zt.ztId,
          },
          param3: zt.bizInfo,
        }),
      );
      dispatch(
        logPostInfo({
          source_p: `${LOG_ACTION_SOURCE.source}||${code}`,
          source_pp: logInfoData.source_p,
        }),
      );
      if (zt.ztId) {
        dispatch(setTopImgVideoVisible({ visible: false, isScrolled: false, data: null }));
        dropScope('special');
        const timer = setTimeout(() => {
          history.push(`${CONTEXT}/special?ztId=${zt.ztId}&bizInfo=${zt.bizInfo}`);
          clearTimeout(timer);
        }, 50);
      }
    },
    [dispatch, code, showName, pageType],
  );

  const handleNumber = (datas = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+datas)) {
      return datas;
    }
    if (+datas < 1000) {
      return datas;
    }
    if (+datas < 10000) {
      return `${(datas / 1000).toFixed(1)}k`;
    }

    return `${(datas / 10000).toFixed(1)}w`;
  };

  const handleMouseLeave = e => {
    if (e && e.currentTarget) {
      e.currentTarget.className = `${e.currentTarget.className} ${styles.image_mouse_out}`;
    }
  };

  const handleShowMore = useCallback(
    bannerInfo => {
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: LOG_ACTION_SOURCE.c_hanlde_more,
          label: '',
          param2: {
            source: `${LOG_ACTION_SOURCE.source}||${code}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            pageCardContentId: showData.pageCardContentId,
            name: showData.name,
            code,
            showName,
            pageType,
          },
          param3: bannerInfo.bizInfo,
        }),
      );
      if (
        bannerInfo.targetType === '1' ||
        bannerInfo.targetType === '3' ||
        bannerInfo.targetType === '11'
      ) {
        dispatch(
          logPostInfo({
            source_p: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId}`,
            source_pp: logInfoData.source_p,
          }),
        );
        let url = `${CONTEXT}/`;
        if (bannerInfo.targetType && bannerInfo.targetContent) {
          url = getUrlByTargetContent(bannerInfo);
        }
        history.push(url);
      } else if (bannerInfo.targetType === '2') {
        if (bannerInfo.targetUrl) {
          window.open(bannerInfo.targetUrl);
        } else if (bannerInfo.targetContent) {
          try {
            const targetContent = JSON.parse(bannerInfo.targetContent) || {};
            window.open(targetContent.targetUrl);
          } catch (error) {}
        }
      } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
        let targetContent = {};
        try {
          targetContent = JSON.parse(bannerInfo.targetContent);
        } catch (error) {
          logNative(`分析商城URL JSON解析错误:${error}`, error);
        }
        if (targetContent && targetContent.url) {
          dispatch(
            setIframeVisible({
              visible: true,
              url: targetContent.url,
              source: LOG_ACTION_SOURCE.source,
            }),
          );
        }
      } else {
        history.push(`${CONTEXT}/error`);
      }
    },
    [dispatch, logInfoData, history, showData, code, showName, pageType],
  );

  return (
    <>
      {showSofts && showSofts.length > 0 ? (
        <div className={styles.card} ref={ref} data-item={data.cardType}>
          <div
            className={classNames(
              styles.card_header,
              logInfo && (logInfo.tag === 'ADetail' || logInfo.tag === 'Detail')
                ? styles.card_header_large
                : '',
            )}
          >
            <div className={classNames(styles.card_header_title)} title={showName}>
              {showName}
            </div>
            {data.operate === '2' && (
              <div className={styles.card_header_more} onClick={() => handleShowMore(data)}>
                更多
              </div>
            )}
          </div>
          <div className={contentClass}>
            {showSofts.slice(0, 6).map((item, index) => (
              <div
                className={classNames(styles.card_item, styles.image_mouse_in)}
                key={index}
                onClick={() => handleZtCard(item)}
                onMouseLeave={handleMouseLeave}
              >
                <div
                  className={classNames(styles.zt_card, {
                    // [styles.zt_card_center]: index % 3 === 1,
                  })}
                  key={`${index}_${item.ztId}`}
                >
                  <div className={classNames(styles.zt_card_img_box)}>
                    <img
                      src={item.contentImg || zt_blank}
                      alt=""
                      className={classNames(styles.zt_card_img)}
                    />
                  </div>
                  <div className={styles.zt_card_title}>{item.contentTitle}</div>
                  <div className={styles.zt_card_info}>
                    <div>{(item.pushTime && dayjs(item.pushTime).format('YYYY/MM/DD')) || ''}</div>
                    <div className={classNames(styles.zt_card_grid_icon)}>
                      <div className={classNames(styles.zt_card_icon)}>
                        <i className="iconfont icon-reads" />
                        <span>{handleNumber(item.watchCount || 0)}</span>
                      </div>
                      <div className={classNames(styles.zt_card_icon)}>
                        <i className="iconfont icon-zan" />
                        <span>{handleNumber(item.zanCount || 0)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
});
